import EpisodePickupListRow from "./EpisodePickupListRow";
import LivePickupListRow from "./LivePickupListRow";
import TVShowPickupListRow from "./TVShowPickupListRow";
import ChannelPickupListRow from "./ChannelPickupListRow";
import AdvertPickupListRow from "./AdvertPickupListRow";

export default function PickupListRow(props) {
  const { item } = props;
  return (
    <>
      {item.__typename === "EpisodeMeta" && <EpisodePickupListRow {...props} />}
      {item.__typename === "LiveMeta" && <LivePickupListRow {...props} />}
      {item.__typename === "TVShowMeta" && <TVShowPickupListRow {...props} />}
      {item.__typename === "ChannelMeta" && <ChannelPickupListRow {...props} />}
      {item.__typename === "Advert" && <AdvertPickupListRow {...props} />}
    </>
  );
}
